import EarthSectionBase from "./EarthSectionBase";
import Projects from "../../pages/Projects";
import {useTranslation} from "react-i18next";

import Mountains from "../../images/assets/sky/SKY2_MOUNTAINS.svg"
import Ground from "../../images/assets/sky/SKY2_FLOOR.webp"

import coin from "../../images/assets/shared/R_COIN.svg";
import {useMemo} from "react";
import CollectibleCoin, {getRandomCoinHover} from "../shared/CollectibleCoin";

export default function Sky2 ({
    layer,
    collectedCoinIds = [],
    onCoinCollect,
    isActive = false
                              }){
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover(), getRandomCoinHover(), getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "sky2-coin-1", className: "sky2-coin", style: coinStyles[0] },
        { id: "sky2-coin-2", className: "sky2-coin2", style: coinStyles[1] },
        { id: "sky2-coin-3", className: "sky2-coin3", style: coinStyles[2] },
    ]

    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={""}
        >
            <h2 className="section-title section-title-position">{t('projectsTitle')}</h2>

            <img src={Mountains} alt="" className={'background-img sky2-mountains'} />
            <img src={Ground} alt="" className={'background-img sky2-ground'} />

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <Projects isActive={isActive}/>
        </EarthSectionBase>
    )
}